const ERROR_NAME = "FourHundredError";

export class FourHundredError extends Error {
  httpResponseCode: number;
  httpResponseBody: unknown;

  constructor(message: string, responseCode: number, responseBody: unknown) {
    super(message);
    this.name = ERROR_NAME;
    this.httpResponseCode = responseCode;
    this.httpResponseBody = responseBody;
  }
}

export const is404Error = (potentialErrorObject: unknown) =>
  potentialErrorObject instanceof Error &&
  potentialErrorObject.name === ERROR_NAME &&
  (potentialErrorObject as FourHundredError).httpResponseCode === 404;

export const isBadRequestError = (potentialErrorObject: unknown) =>
  potentialErrorObject instanceof Error &&
  potentialErrorObject.name === ERROR_NAME &&
  (potentialErrorObject as FourHundredError).httpResponseCode === 400;
